export default "__VITE_ASSET__BR53drJW__"